<template>
    <section class="tekst green">
        <circles-layout class="green"></circles-layout>
        <h1>Duurzaam verbeteren</h1>
        <p>Duurzaam onderwijs is een continu proces waarbij iedere betrokkene leert over leren. Het onderwijs is steeds in ontwikkeling om in te spelen op de huidige maatschappij en voorbereid te zijn op de carri&egrave;rekansen van morgen. Leerlingen, studenten, leraren, directies, ouders en onderwijsondersteuners voeden het proces en worden erdoor gevoed. Duurzaam onderwijs wordt niet door een beleidsinstantie of universiteit opgelegd of klaargemaakt, maar ontstaat door mensen die ermee werken.</p>
        <p>De instrumenten die bij duurzaam onderwijs horen, helpen ons om het onderwijs iedere dag te verbeteren. Met HRM ontwikkelden we een lean toolbox voor onderwijsteams en werd een toolbox ontwikkeld om <i>lean</i> werken te integreren in het onderwijs.</p>
        <p>Ook werd in 2020 het Studenten Adviespunt 013 (STAP 013) opgericht. Zij betrekken studenten bij het verbeteren van het onderwijs. Door structureel in dialoog te zijn met hen, wordt het onderwijs dagelijks &mdash; in kleine stapjes &mdash; verbeterd.</p>
    </section>
</template>

<style lang="scss" scoped>
    // see /static/scss/pages/_tekst.scss
</style>

<script>
    import Circles from '@/app/components/circles';
    export default {
        name: 'DuurzaamIntro',
        meta: {
            title: 'DuurzaamIntro',
            color: '#12C470'
        },
        components: {
            'circles-layout': Circles
        },
        methods: {
            focus()
            {
                // console.log( 'animateIn' );
            }
        }
    };
</script>
